import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useSelector, useDispatch } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
import {
    Modal,
    createStyles,
    ScrollArea,
    Card,
    Text
} from '@mantine/core';
//descript: our work
import {
    fieldInfoUpdated,
    selectSectionData,
} from '../features/home/homeSlice';

import { useViewportSize } from '@mantine/hooks';
import { FooterSimple } from '../components/FooterSimple';
import { MobileSimpleHeader } from '../components/MobileSimpleHeader';

//import { TheAccordianCard } from '../components/AccordianCard';
//import AuthLogInCard from '../components/AuthLogInCard';
import { AuthLogInCard } from '../components/AuthLogInCard';
import { AuctionItemMgmtFilter } from '../components/AuctionItemMgmtFilter';
import { AuctionItemMgmtItem } from '../components/AuctionItemMgmtItem';



//add a progress bar at the top
import skull_640 from '../assets/skull_640.png';
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
import pagani from '../assets/pagani.jpg';


const useStyles = createStyles((theme) => ({
    centerComps: {
        margin: '0 auto'
    },
    noListingsContain: {
        maxWidth: '800px',
        width: '80%',
        margin: '0 auto'
    }
}));


//this needs params
//neded:post contents of fields and retrieve the tokens (use aclient.js)
const LogInPage = () => {
    const { classes, theme } = useStyles();
    const { height, width } = useViewportSize();

    let no_listings = <Card withBorder radius="md" className={classes.noListingsContain}><Text ta="center">No Cars In Your Inventory</Text></Card>

    return (
        <>
            <br/>
            <AuthLogInCard />
        </>
    )
}

export default LogInPage

